module.exports = __webpack_public_path__ + "static/mascot-affiliate-66a0bdee5b5561e5c7475ea2b3245fc3.png";